A date string compliant with RFC 3339.
